(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/accountservices/page-menu/assets/javascripts/use-header-hook.js') >= 0) return;  svs.modules.push('/components/accountservices/page-menu/assets/javascripts/use-header-hook.js');
'use strict';

var _svs$core$template$ge;
const _React = React,
  useEffect = _React.useEffect;
const moduleTitle = (_svs$core$template$ge = svs.core.template.getConfig()) === null || _svs$core$template$ge === void 0 || (_svs$core$template$ge = _svs$core$template$ge.title) === null || _svs$core$template$ge === void 0 || (_svs$core$template$ge = _svs$core$template$ge.row1) === null || _svs$core$template$ge === void 0 ? void 0 : _svs$core$template$ge.text;


const useHeader = () => {
  let defaultTitle = moduleTitle || undefined;

  const updateHeaderButton = (func, leftButtons) => {
    if (func) {
      svs.components.navigation.hideHamburger();
    } else {
      svs.components.navigation.showHamburger();
    }
    svs.core.template.updateConfig({
      leftButtons: func ? leftButtons : []
    });
  };
  const setBackBtnFunc = backFunc => {
    const leftButtons = [{
      id: 'page-menu-mobile-nav-back',
      action: backFunc,
      cssClass: 'border-0 page-menu-mobile-nav-back padding-v padding-h-1 pointer u-inline-block',
      content: '<i class="icon fc-black account-icon-height-adjust icon-200 icon-arrow-left"></i>'
    }];
    if (backFunc) {
      updateHeaderButton(backFunc, leftButtons);
    } else {
      updateHeaderButton(null);
    }
  };
  const setTitle = (title, defTitle) => {
    if (defTitle) {
      defaultTitle = defTitle;
    }
    if (title) {
      svs.core.template.updateConfig({
        title: {
          row1: {
            text: title
          }
        }
      });
    } else {
      svs.core.template.updateConfig({
        title: {
          row1: {
            text: defaultTitle
          }
        }
      });
    }
  };
  useEffect(() => () => {
    updateHeaderButton(null, []);
    if (defaultTitle) {
      setTitle(defaultTitle);
    }
  });
  return {
    setBackBtnFunc,
    setTitle
  };
};
svs.accountservices.pageMenu.useHeader = useHeader;

 })(window);